import { Injectable, inject, signal } from "@angular/core";
import { CurrentUserProfileApiService } from "./current-user-profile.api.service";

@Injectable({
  providedIn: "root",
})
export class ProfileAvatarUiService {
  readonly #api = inject(CurrentUserProfileApiService);

  /** URL absoluta legada o object URL de blob; undefined = placeholder. */
  readonly avatarSrc = signal<string | undefined>(undefined);

  #blobObjectUrl: string | undefined;

  async refresh(): Promise<void> {
    this.#clearBlobUrl();
    this.avatarSrc.set(undefined);
    try {
      const me = await this.#api.getByToken();
      const legacy = me.profilePic?.trim() ?? "";
      if (legacy && /^https?:\/\//i.test(legacy)) {
        this.avatarSrc.set(legacy);
        return;
      }
      if (!me.hasProfilePicture) {
        return;
      }
      const blob = await this.#api.getProfilePictureBlob();
      const url = URL.createObjectURL(blob);
      this.#blobObjectUrl = url;
      this.avatarSrc.set(url);
    } catch {
      this.avatarSrc.set(undefined);
    }
  }

  clear(): void {
    this.#clearBlobUrl();
    this.avatarSrc.set(undefined);
  }

  #clearBlobUrl(): void {
    if (this.#blobObjectUrl) {
      URL.revokeObjectURL(this.#blobObjectUrl);
      this.#blobObjectUrl = undefined;
    }
  }
}
